export const numToHuf = (number: number) => {
  const num = Number(number);
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " Ft";
};
